<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />

        <h2 class="brand-text text-primary ml-1">
          StudyPress
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <!-- <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          /> -->
          <b-img
            fluid
            :src="`${baseURL}assets/images/pages/register-v2.svg`"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-overlay :show="loading">
          <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
            <b-card-title class="mb-1">
              Create Your Account
            </b-card-title>
            <b-alert :show="errorAlert" variant=" " dismissible fade class="text-white bg-danger">
              <div class="iq-alert-icon">
                <i class="ri-information-line"></i>
              </div>
              <div class="iq-alert-text">{{ errorMsg }}</div>
            </b-alert>
            <!-- form -->
            <validation-observer ref="registerForm">
              <b-form class="auth-register-form mt-2" @submit.prevent="userRegister()">
                <!-- username -->
                <b-form-group label="Name" label-for="register-username">
                  <validation-provider #default="{ errors }" name="Name" vid="name" rules="required">
                    <b-form-input
                      id="register-username"
                      v-model="user.name"
                      name="register-username"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Enter name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- email -->
                <b-form-group label="Email" label-for="register-email">
                  <validation-provider #default="{ errors }" name="Email" vid="email" rules="required|email">
                    <b-form-input
                      id="register-email"
                      v-model="user.email"
                      name="register-email"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Enter email"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- phone -->
                <b-form-group label="Phone" label-for="register-phone">
                  <validation-provider #default="{ errors }" name="Phone" rules="required">
                    <b-form-input
                      id="register-phone"
                      v-model="user.phone"
                      name="register-phone"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Enter phone."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- password -->
                <b-form-group label-for="register-password" label="Password">
                  <validation-provider #default="{ errors }" name="Password" vid="password" rules="required">
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="register-password"
                        v-model="user.password"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        :state="errors.length > 0 ? false:null"
                        name="register-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          :icon="passwordToggleIcon"
                          class="cursor-pointer"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger">{{ passwordErrorMsg }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <validation-provider #default="{ errors }" name="Agreement" vid="agree" rules="required">
                    <b-form-checkbox
                      id="register-privacy-policy"
                      v-model="user.agree"
                      name="checkbox-1"
                      :state="errors.length > 0 ? false:null"
                    >
                      I agree to
                      <b-link to="/site/privacy-policy-and-terms">privacy policy & terms</b-link>
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  variant="primary"
                  block
                  type="submit"
                >
                  Register
                </b-button>
              </b-form>
            </validation-observer>

            <p class="text-center mt-2">
              <span>Already have an account?</span>
              <b-link :to="{name:'auth-login'}">
                <span>&nbsp;Log in instead</span>
              </b-link>
            </p>
          </b-col>
          <template #overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p id="cancel-label">Please wait...</p>
            </div>
          </template>
        </b-overlay>
      </b-col>
    <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import RestApi, { studyPressBaseUrl } from '@/config/api_config'
import { passportApiRegister } from '../../api/routes'
import ModalBaseMasterList from '@core/mixins/modal-base-master-list'

export default {
  components: {
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, ModalBaseMasterList],
  data() {
    return {
      baseURL: studyPressBaseUrl,
      status: '',
      passwordErrorMsg: '',
      username: '',
      userEmail: '',
      password: '',
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      user: {
        name: '',
        email: '',
        phone: '',
        password: '',
        invitation_token: '',
        agree: '',
      },
      // validation
      required,
      email,
      loading: false,
      errorAlert: false,
      errorMsg: ''
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created () {
    this.user.invitation_token = this.$route.params.invitation_token
    if (this.$route.params.invitation_token) {
      this.emailVerifyByToken(this.$route.params.invitation_token)
    }
  },
  methods: {
    async emailVerifyByToken (invitation_token) {
      this.loading = true
      const params = { invitation_token: invitation_token}
      const result = await RestApi.postData(studyPressBaseUrl, `api/auth/joining_group_invitation_token_verify`, params)
      this.loading = false

      if (result && result.success) {
        this.user.email = result.email
        this.resMsg(result.msg, 'success', 'Token Verify')
      } else {
        this.resMsg(result.msg, 'danger')
      }
    },
    userRegister() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          if (this.user.password.length < 6) {
            this.passwordErrorMsg = 'Password should be minimum 6 digits'
          } else {
            this.passwordErrorMsg = ''
            this.loading = true
            RestApi.postData(studyPressBaseUrl, 'api/auth/register', this.user)
            .then((result) => {
              this.loading = false
              if (result.success) {
                const userData = result.data
                this.$router.push('/site/login')
                  .then(() => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: `Welcome ${userData.name}`,
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: `Your account has been created successfully!`,
                      },
                    })
                  })
              } else {
                this.resMsg(result.msg, 'danger')
                this.errorMsg = 'Failed to sign up. Please, try again.'
              }
            }).catch(error => {
              this.resMsg(error.msg, 'danger')
            })
          }
        }
      })
    },
    // async register() {
    //   if (this.user.phone === '') {
    //     this.phoneErrorMsg = 'Phone field is required!'
    //   } else {
    //     const result = await RestApi.postData(studyPressBaseUrl, passportApiRegister, this.user)
    //     if (result.success) {
    //       const { userData } = result.data
    //       this.$router.push('/login')
    //         .then(() => {
    //           this.$toast({
    //             component: ToastificationContent,
    //             position: 'top-right',
    //             props: {
    //               title: `Welcome ${userData.name}`,
    //               icon: 'CoffeeIcon',
    //               variant: 'success',
    //               text: `Your account has been created successfully!`,
    //             },
    //           })
    //         })
    //     } else {
    //       this.errorAlert = true
    //       this.errorMsg = 'Failed to sign up. Please, try again. ttt'
    //       this.$refs.form.setErrors(result.errors)
    //     }
    //   }
    // },
    // register() {
    //   this.$refs.registerForm.validate().then(success => {
    //     if (success) {
    //       useJwt.register({
    //         username: this.username,
    //         email: this.userEmail,
    //         password: this.password,
    //       })
    //         .then(response => {
    //           useJwt.setToken(response.data.accessToken)
    //           useJwt.setRefreshToken(response.data.refreshToken)
    //           localStorage.setItem('userData', JSON.stringify(response.data.userData))
    //           this.$ability.update(response.data.userData.ability)
    //           this.$router.push('/')
    //         })
    //         .catch(error => {
    //           this.$refs.registerForm.setErrors(error.response.data.error)
    //         })
    //     }
    //   })
    // },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
